import {LocalizedDictionary} from '../Translator';

export default {
  "DD": "DD",
  "Discontinued": "Beëindigd",
  "Spare part list": "Lijst met reserveonderdelen",
  "Download Excel": "Excel downloaden",
  "Recent search list": "Recente zoeklijst",
  "No data": "Geen gegevens",
  "spare part": "reserveonderdeel",
  "none": "geen",
  "no value": "geen waarde",
  "No results found": "Geen resultaten gevonden",
  "Spare parts for": "Reserveonderdelen voor",
  "Could not load cumulated data": "Kon gecumuleerde gegevens niet laden",
  "commissioning part": "inbedrijfstellingsdeel",
  "wear part": "slijtdeel",
  "Search": "Zoek op",
  "Tk": "Tk",
  "Spare part number": "Reserveonderdeelnummer",
  "drawing": "tekening",
  "Products for": "Producten voor",
  "Available": "Beschikbaar",
  "MM": "MM",
  "The entered order code is invalid": "De ingevoerde bestelcode is ongeldig",
  "Recommended": "Aanbevolen",
  "No data available for the entered search parameters": "Geen gegevens beschikbaar voor de ingevoerde zoekparameters",
  "Search spare parts": "Onderdelen zoeken",
  "Order code / product root / serial number": "Bestelcode / productwortel / serienummer",
  "Characteristic": "Kenmerk",
  "Please enter an order code": "Voer een bestelcode in",
  "Regarding quality- and security-aspects Endress+Hauser strongly recommends the exclusive use of genuine Endress+Hauser spare parts. The instrument may only be maintained and repaired by qualified personnel. The device documentation, applicable standards and legal requirements as well as any certificates have to be observed!": "Met betrekking tot kwaliteits- en veiligheidsaspecten beveelt Endress+Hauser sterk aan om uitsluitend originele Endress+Hauser reserveonderdelen te gebruiken. \nHet instrument mag alleen worden onderhouden en gerepareerd door gekwalificeerd personeel. \nDe documentatie over het apparaat, de van toepassing zijnde normen en wettelijke vereisten en eventuele certificaten moeten worden nageleefd!",
  "Maintenance advice": "Advies over onderhoud",
  "Mo.": "Mo.",
  "For which product(s) can my spare part be used? Filling in the spare part order code (e.g. 71002865 or XPD0024) shows the relevant devices this spare part can be used in.": "Voor welk(e) product(en) kan mijn reserveonderdeel worden gebruikt? Als je de bestelcode van het reserveonderdeel invult (bijv. 71002865 of XPD0024), zie je in welke apparaten dit reserveonderdeel kan worden gebruikt.",
  "tool": "gereedschap",
  "Production numbers": "Productieaantallen",
  "New alternative": "Nieuw alternatief",
  "There are no items selected. Please use the checkboxes to make your selection": "Er zijn geen items geselecteerd. Gebruik de selectievakjes om uw keuze te maken",
  "Service segmentation": "Service segmentatie",
  "Seg": "Seg",
  "Valid": "Geldig",
  "Pos": "Pos",
  "Value": "Waarde",
  "service segmentation 2": "Onderdelen die basiskennis vereisen. Succesvolle deelname aan de E+H basistraining is een vereiste.",
  "Phase out date": "Uitfaseringsdatum",
  "service segmentation 1": "Onderdelen die basiskennis vereisen.",
  "Which spare parts are available for my product? Filling in the order code (e.g. FTC260-AA2A1 or PMC51-BA21JB1CGBTDJB) or the product id (e.g. FTC260 or 83F50) shows the relevant spare parts.": "Welke reserveonderdelen zijn er beschikbaar voor mijn product? Als u de bestelcode (bijv. FTC260-AA2A1 of PMC51-BA21JB1CGBTDJB) of de productcode (bijv. FTC260 of 83F50) invult, worden de relevante reserveonderdelen weergegeven.",
  "Set filter": "Filter instellen",
  "Search date": "Zoekdatum",
  "Group": "Groep",
  "Warning": "Waarschuwing",
  "Description": "Beschrijving",
  "Cancel": "Annuleren",
  "service segmentation 4": "Onderdelen voor reparatie in de fabriek. Vakkennis is verplicht.",
  "service segmentation 3": "Onderdelen die gespecialiseerde kennis vereisen. Succesvolle deelname aan E+H-training voor gevorderden is een vereiste.",
  "Drawing Position Number": "Tekening Positie Nummer",
  "Spare parts search": "Onderdelen zoeken",
  "Confirm": "Bevestig",
  "Ordercode too short": "Bestelcode te kort",
  "Product status": "Productstatus",
  "Open": "Open",
  "Clear": "Duidelijk",
  "PDF file with assembly instructions": "PDF-bestand met montage-instructies",
  "Search products": "Producten zoeken",
  "Export": "Exporteer",
  "Production date": "Productiedatum",
  "Order stop": "Bestelstop",
  "Calibration until": "Kalibratie tot",
  "PDF file with compatibility information": "PDF-bestand met compatibiliteitsinformatie",
  "Add selection to cart": "Selectie aan winkelwagentje toevoegen",
  "Mounting advices": "Montage adviezen",
  "Recommended parts only": "Alleen aanbevolen onderdelen",
  "not applicable": "niet toepasbaar",
  "accessories": "accessoires",
  "Cumulative spare parts list": "Cumulatieve lijst met reserveonderdelen",
  "YYYY": "JJJJ",
  "Title": "Titel",
  "Error": "Fout",
  "Ordercode too long": "Bestelcode te lang",
  "Functions": "Functies",
  "Rec": "Rec",
  "Type": "Type",
  "Spare sensor until": "Reservesensor tot",
  "Spare parts until": "Reserveonderdelen tot",
  "Filter": "Filter",
  "Check all": "Alles controleren",
  "Order code": "Bestelcode",
  "Repair until": "Repareren tot",
  "Tag": "Label",
  "Ok": "Ok",
  "Category code": "Categorie code",
  "Phase out": "Uitfaseren",
  'Compatibility advices': 'Aanvullende documenten',
  'Co.': 'Aanv. doc.',
} as LocalizedDictionary;
